import { render, staticRenderFns } from "./WorkDetailLayout.vue?vue&type=template&id=60811879&"
import script from "./WorkDetailLayout.vue?vue&type=script&lang=js&"
export * from "./WorkDetailLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports